import { useContext, useDebugValue } from "react";
import { jwtDecode } from "jwt-decode";
import AuthContext from "../../context/AuthContext";

const useAuth = () => {
  const { auth } = useContext(AuthContext);
  const decoded = auth?.accessToken ? jwtDecode(auth.accessToken) : undefined;
  useDebugValue(decoded, (a) => (a?.userName ? "Logged In" : "Logged Out"));

  return useContext(AuthContext);
};

export default useAuth;
